export const SOLID_LEAD_PX = 48;

export function isOverHero(contentEdge: number, navbarHeight: number): boolean {
  return contentEdge > navbarHeight + SOLID_LEAD_PX;
}

export interface SectionPosition {
  key: string;
  top: number;
}

export function activeSectionKey(
  sections: SectionPosition[],
  line: number,
  atPageBottom: boolean,
): string | null {
  const last = sections.at(-1);
  if (atPageBottom && last) return last.key;
  return sections.filter((section) => section.top <= line).at(-1)?.key ?? null;
}
